
import { StopLicenseActions, StopLicenseActionTypes } from '../actions/stop-license.actions';

export interface State {
  isLoaded: boolean;
  isLoading: boolean;
}

export const initialState: State = {
  isLoaded: false,
  isLoading: false
};

export function reducer(state = initialState, action: StopLicenseActions): State {
  switch (action.type) {
    case StopLicenseActionTypes.LoadStopLicenses:
      return state;

    default:
      return state;
  }
}
